export default __webpack_public_path__ + "static/opengraph-83eb8c7d48c7acb894632ce402e05bed.png";